const styles = theme => ({
  root: {
    width: '100%',
  },
  container: {
    width: '100%',
    padding: theme.spacing(2),
  },
  rowInput: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  input: {
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2),
    },
  },
  inputHalf: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(50% - ${theme.spacing(2)}px)`,
    },
  },
  discountTitle: {
    marginTop: theme.spacing(5),
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  buttonSave: {
    marginRight: theme.spacing(1),
  },
})

export default styles
